import React, { FC } from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import DsfMismatchFormContinueButton from "./DsfMismatchFormContinueButton";
import { CART_ITEM_TYPE, FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import * as CHECKOUT_AT from "../../../state/actionTypes";
import { getAllItemsOfType, hasHandsetItems, hasPreownedHandsetItems } from "../../../state/selectors/cartSelectors";
import * as COMBINED_SELECTORS from "../../../state/selectors/combinedSelectors";
import { canContinuePersonalDetails as canContinuePersonalDetailsSelector } from "../../../state/selectors/formSelectors";
import { hasSubscriptions } from "../../../state/selectors/subscriptionsSelectors";
import * as VERIFICATION_SELECTORS from "../../../state/selectors/verificationSelectors";
import TEXT from "../../../text-consts";

interface StateProps {
    canContinuePersonalDetails: boolean;
    isDsfMismatch: boolean;
    isHardwareOnly: boolean;
    isHwOnlyButRequireBankid: boolean;
    isMobilPantBlockingContinue: boolean;
    isMultipleSubscriptions: boolean;
    isSettingPersonalDetails: boolean;
}

const PersonalDetailsContinueButton: FC<StateProps> = ({
    isSettingPersonalDetails,
    isMultipleSubscriptions,
    isHardwareOnly,
    canContinuePersonalDetails,
    isDsfMismatch,
    isHwOnlyButRequireBankid,
    isMobilPantBlockingContinue,
}) => {
    if (isDsfMismatch) {
        return <DsfMismatchFormContinueButton />;
    }
    if (!canContinuePersonalDetails) {
        return null;
    }

    return (
        <Button
            className="beta-checkout__continue-button-container__button"
            id="personal-details-form-button"
            form={isHardwareOnly && !isHwOnlyButRequireBankid ? FORM_ID.PERSONAL_DETAILS : FORM_ID.CONTACT_INFO}
            loading={isSettingPersonalDetails}
            variant="primary"
            disabled={!canContinuePersonalDetails || isMobilPantBlockingContinue}
            type="submit"
        >
            {isMultipleSubscriptions ? TEXT.MULTIPLE_SUBSCRIPTIONS.CONTINUE : TEXT.COMMON.CONTINUE}
        </Button>
    );
};

const mapStateToProps = (state: RootState): StateProps => {
    const hasMobileRefund = getAllItemsOfType(state, CART_ITEM_TYPE.MOBILE_REFUND).length > 0;
    const hasHandset = hasHandsetItems(state) || hasPreownedHandsetItems(state);
    const hasSubscription = hasSubscriptions(state);

    return {
        isSettingPersonalDetails: LOADING_SELECTORS.isTypeLoading(state, CHECKOUT_AT.CHECKOUT_SET_PERSONAL_DETAILS),
        isMultipleSubscriptions: COMBINED_SELECTORS.isMultipleSubscriptions(state),
        isHardwareOnly: COMBINED_SELECTORS.isHardwareOnly(state),
        isHwOnlyButRequireBankid: COMBINED_SELECTORS.isHwOnlyButRequireBankid(state),
        canContinuePersonalDetails: canContinuePersonalDetailsSelector(state),
        isDsfMismatch: VERIFICATION_SELECTORS.isDsfMismatch(state),
        isMobilPantBlockingContinue: hasMobileRefund && !(hasHandset && hasSubscription),
    };
};

export default connect(mapStateToProps)(PersonalDetailsContinueButton);
